import { Burger, Center, Flex, Group, Image, Stack } from '@mantine/core';
import { IconChevronLeft as LeftIcon, IconChevronRight as RightIcon } from '@tabler/icons-react';
import { ReactNode } from 'react';

import classes from './Sidebar.module.css';
import logoSrc from './assets/logo.png';
import { SidebarItem, useSidebarItems, useSidebarState } from './hooks/useSidebar';

interface SidebarProps {
  toggleMenu: () => void;
  opened: boolean;
  items: SidebarItem[];

  header?: ReactNode;
}

export function Sidebar({ toggleMenu, opened, items, header }: SidebarProps) {
  const { isMainActive, toggleMainActive } = useSidebarState();
  const links = useSidebarItems({ items, isCollapsed: !isMainActive, baseUrl: null });
  return (
    <nav className={classes.navbar}>
      <Flex
        justify="space-between"
        direction="column"
        data-collapsed={!isMainActive}
        className={classes.navbarMain}
      >
        <div
          onClick={toggleMainActive}
          data-collapsed={!isMainActive}
          className={classes.sidebarToggle}
        >
          {isMainActive ? <LeftIcon /> : <RightIcon />}
        </div>
        <Stack>
          <Group
            className={classes.header}
            justify="space-between"
            align="center"
          >
            <Center
              mt="15px"
              w="100%"
            >
              <Image
                h={isMainActive ? '80px' : '30px'}
                src={logoSrc}
              />
            </Center>
            <Burger
              opened={opened}
              onClick={toggleMenu}
              hiddenFrom="sm"
              size="sm"
            />
          </Group>
          {header}
          {links}
        </Stack>
      </Flex>
      <div
        id="context-sidebar"
        style={{ overflowX: 'scroll' }}
        data-collapsed={isMainActive}
        className={classes.contextSidebar}
      />
    </nav>
  );
}
